<template>
  <!-- <div :class="fixedDiv ? 'fixedDiv whiteNav': isIndex  ? 'absoluteDiv navBarView': 'whiteNav'" -->

  <div
    :class="fixedDiv ? 'fixedDiv whiteNav' : isIndex ? 'absoluteDiv navBarView' : 'whiteNav'"
    class="noneSelect font16"
  >
    <div class="navBar dfcjsb">
      <div class="logoView dfc">
        <router-link to="/" class="dfc">
          <img src="../../assets/logo3.png" alt class="mr10" v-if="!isIndex" />
          <img src="../../assets/logo.png" alt class="mr10" v-else-if="!fixedDiv" />
          <img src="../../assets/logo3.png" alt class="mr10" v-else-if="fixedDiv" />
          <span class="logoText">| 电商企业智能工具平台</span>
        </router-link>
      </div>
      <div class="center dfc">
        <li v-for="(item, index) in navList" :key="index">
          <template v-if="!item.outHref && !item.link">
            <el-popover placement="top-start" trigger="hover" v-if="item.children">
              <a href="javascript:;" slot="reference">
                {{ item.text }}
              </a>

              <div class="navChildrenItem" v-for="value in item.children" :key="value.text">
                <a :href="value.outHref" target="_blank">
                  {{ value.text }}
                </a>
              </div>
            </el-popover>
          </template>
          <template v-else>
            <a v-if="item.outHref" :href="item.outHref" target="_blank"> {{ item.text }}</a>
            <template v-else
              ><router-link
                style="position: relative"
                :to="item.link"
                :class="item.isCurr ? 'curr' : ''"
                v-if="!item.children"
              >
                <span @click="_html(item.text)"> {{ item.text }}</span>

                <div
                  v-if="item.name == 'buy'"
                  class="iconClass"
                  :class="[isRouterPath ? 'bg-blue' : 'bg-red']"
                  alt=""
                >
                  低至9元
                </div>
              </router-link>
              <el-popover placement="top-start" trigger="hover" v-if="item.children">
                <router-link :to="item.link" :class="item.isCurr ? 'curr' : ''" slot="reference">
                  {{ item.text }}
                </router-link>
                <div v-for="(item2, index2) in item.children" class="navChildrenItem" :key="index2">
                  <router-link :to="item2.link" :title="item2.text">
                    <span @click="_html(item2.text)"> {{ item2.text }}</span>
                  </router-link>
                </div>
              </el-popover></template
            >
          </template>
        </li>
      </div>
      <div class="right dfc font14">
        <div class="notLogin dfc" v-if="!userPhone">
          <div class="curp" @click="toLogin">登录</div>
          <span class="ml5 mr5">/</span>
          <div class="curp" @click="toRegist">注册</div>
        </div>
        <div class="loginedView dfc" v-if="userPhone">
          <el-popover
            placement="bottom"
            width="220"
            trigger="hover"
            popper-class="logined"
            :visible-arrow="false"
          >
            <div class="userInfoIcon" slot="reference">
              <img src="../../assets/user.png" alt />
            </div>
            <div class="userInfo">
              <div class="account dfc">
                <div>
                  <p class="font16 fontw" style="color: #000">
                    {{ hideTel(userPhone) }}
                  </p>
                </div>
              </div>
              <div class="useStatus">
                <div class="dfcjsb">
                  <p class="font12">
                    剩余产品检测数：
                    <span class="buy">{{ packageCount.productCount }}</span
                    >个
                  </p>
                  <p class="curp" style="color: #1c64f4" @click="buyBtn(0, 0)">充值</p>
                  <!-- <router-link to="/buy?navTag=3"
                               class="blueFont"
                               style="color: #1c64f4;">购买</router-link> -->
                </div>
                <div class="dfcjsb">
                  <p class="font12">
                    剩余图片检测数：
                    <span class="buy">{{ packageCount.imageCount }}</span
                    >张
                  </p>
                  <p class="curp" style="color: #1c64f4" @click="buyBtn(1, 0)">充值</p>
                  <!-- <router-link to="/buy?navTag=3" class="blueFont" style="color: #1c64f4;">购买</router-link> -->
                  <!-- <p class="buy curp">购买</p> -->
                </div>
              </div>
              <div class="option dfc">
                <div>
                  <p class="dfc curp">
                    <img src="../../assets/shopManage.png" alt class="mr10" />
                    <!--<span>店铺管理</span>-->
                    <router-link to="/shopsManagement">店铺管理</router-link>
                  </p>
                  <p class="mt15 dfc curp" @click="loginOut">
                    <img src="../../assets/logOut.png" alt class="mr10" />
                    <span class="color33">退出账号</span>
                  </p>
                </div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <reg ref="reg" @showUserPack="showUserPack" @reload="reload"></reg>
    <login ref="login" @reload="reload" @showUserPack="showUserPack"></login>
    <changeReg ref="changeReg"></changeReg>
    <chooseCombo ref="chooseCombo" @buySuccess="getAliPackageCount"></chooseCombo>
    <userPact ref="userPact"></userPact>

    <industryTes ref="industryTes" class="industryTes"></industryTes>

    <fixed-into v-show="fixedShow" @reload="reload"></fixed-into>
  </div>
</template>

<script>
import reg from "@/components/reg";
import login from "@/components/login";
import userPact from "@/views/contactUs/userPact.vue";
import changeReg from "@/components/changeReg";
import chooseCombo from "../illegalWord/components/chooseCombo";
import industryTes from "../../components/industryTes/industryTes";
import FixedInto from "../illegalWord/aliProduct/components/fixedViewDialog/index";
import Cookies from "js-cookie";
// FixedInto
import { mapState } from "vuex";
// import { isBefore } from "@/utils/index.js";

export default {
  components: {
    reg,
    login,
    changeReg,
    chooseCombo,
    userPact,
    industryTes,
    FixedInto,
  },
  props: ["idFixedDiv", "isIndexDiv"],
  data() {
    return {
      fixedShow: false,
      fixedDiv: this.idFixedDiv ? this.idFixedDiv : false,
      isIndex: this.isIndexDiv ? this.isIndexDiv : false,
      navList: [
        {
          text: "首页",
          link: "/",
          isCurr: true,
          name: "index",
          isIcon: true,
        },
        {
          text: "违禁词检测",
          link: "/illegalWord",
          isCurr: false,
          isIcon: true,
          name: "aliProduct",
          children: [
            {
              link: "/illegalWord/aliProduct",
              text: "1688产品检测",
              index: "1",
            },
            {
              link: "/illegalWord/imgCheck",
              text: "图片违禁词检测",
              index: "2",
            },
            {
              link: "/illegalWord/textCheck",
              text: "文字违禁词检测",
              index: "3",
            },
            // { link: "/illegalFont/fontCheck", text: "方正字体检测", index: "5" },
            {
              link: "/illegalWord/manageIllgalWord",
              text: "管理词库",
              index: "4",
            },
          ],
        },

        {
          text: "方正字体检测",
          link: "/illegalFont/fontCheck",
          isCurr: false,
          name: "fontCheck",
          isIcon: true,
        },
        {
          text: "智能工具",
          isCurr: false,

          children: [
            {
              text: "商机助理",
              outHref: "https://pc.1688.com/product/operate.htm?key=k_10256910",
              index: "1",
            },
            {
              text: "店铺装修",
              outHref: "https://pc.1688.com/product/operate.htm?key=k_daze1217",
              index: "2",
            },
            {
              text: "流量推广",
              outHref: "https://pc.1688.com/product/operate.htm?key=k_10251246",
              index: "3",
            },
            {
              text: "慧眼识货",
              outHref:
                "https://pc.1688.com/product/detail.htm?productCode=esNsfkc8n%2FbcJkwz4JVKvKK0V3LiFQPfCWlc9XdcPgo%3D&productType=GROUP",
              index: "4",
            },
            {
              text: "数据分析",
              outHref:
                "https://pc.1688.com/product/detail.htm?productCode=PdFy%2FlCnceqrB3J5NgFANvIZC%2B7fABvnOqEwWertaEE%3D&productType=GROUP",
              index: "5",
            },
            {
              text: "档口ERP",
              outHref:
                "https://pc.1688.com/product/detail.htm?productCode=3F%2BIYCQ8XYyXRPwdGMzRkKdp4yl13%2BJzvw%2FnryyOODg%3D&productType=GROUP",
              index: "6",
            },
          ],
        },
        {
          text: "经营神器",
          link: "/flow",
        },
        {
          text: "购买",
          link: "/buy",
          isCurr: false,
          name: "buy",
          isIcon: true,
        },
        {
          text: "联系我们",
          link: "/contactUs",
          isCurr: false,
          name: "contactUs",
          isIcon: true,
        },
      ],
      showLogin: this.userPhone,
      // productPackage: "", //产品套餐
      productPackageTypeOne: [],
      productPackageTypeTwo: [],
      imagePackage: [],
      isIcon: true,
      isRouterPath: true,
    };
  },
  computed: {
    // isBefore() {
    //   return isBefore("2020-11-05");
    // },
    ...mapState(["userPhone", "packageCount", "shopToolToken", "loginMode"]),
    nativeList() {
      let contai = [];
      this.$router.options.routes.map((el, i) => {
        if (el.meta && el.meta.isNavList == true) {
          contai.push(el);
        }
      });
      return contai;
    },
  },

  updated() {
    //this.checkTag();
    //this.getAliPackageCount()
  },
  watch: {
    async "$store.state.shopToolToken"() {
      let shopToken = this.shopToolToken;
      if (!shopToken) return;
      let res = await this.getKuaiOMemberInfo(shopToken);
      if (res === false) {
        this.$store.commit("setRegVisible", true);
        return;
      }
      let userInfo = {
        mobilePhone: Number(res.mobilePhone),
        password: "",
      };
      this.$store.commit("setUserInfoCache", userInfo);
      setTimeout(() => {
        // this.$store.state.loginMode = 1;
        this.$store.commit("setLoginVisible", true);
      }, 300);
    },
  },
  async mounted() {
    this.isRouterPath = this.isBuy();
    this.getAliPackageCount();
    if (!this.isIndexDiv) this.isIndex = this.$route.name === "index";
    this.checkTag();
    if (this.isIndex && !this.isIndexDiv)
      window.addEventListener("scroll", this.handleScroll, true);
    let shopToken = this.shopToolToken;
    if (shopToken) {
      let res = await this.getKuaiOMemberInfo(shopToken);
      if (res === false) {
        // this.$store.commit("setRegVisible", true);
        this.$store.state.loginMode = 1;
        this.$store.commit("setLoginVisible", true);
        return;
      }
      let userInfo = {
        mobilePhone: Number(res.mobilePhone),
        password: "",
      };
      this.$store.commit("setUserInfoCache", userInfo);
      setTimeout(() => {
        // this.$store.state.loginMode = 1;
        this.$store.commit("setLoginVisible", true);
      }, 300);
      return;
      this.$refs.login.phone = res.mobilePhone;
    }
    setTimeout(() => {
      this.fixedShow = true;
    }, 2000);
  },
  methods: {
    // 判断是否是购买页面
    isBuy() {
      return location.href.indexOf("/buy") > -1 ? true : false;
    },
    _html(parms) {
      _hmt.push(["_trackEvent", "顶部菜单", `·${parms}·点击`]);
    },
    reload() {
      console.log("reload", 0);
    },
    isIconFun(t) {
      if (t === 1) {
        this.isIcon = true;
      } else {
        this.isIcon = false;
      }
    },
    checkTag() {
      if (this.$route.name == "aliProduct") {
        this.isIcon = true;
      } else {
        this.isIcon = false;
      }
      this.navList.forEach((item) => {
        if (this.$route.path.indexOf(item.link) != -1) item.isCurr = true;
        if (this.$route.path != item.link) item.isCurr = false;
        if (item.children) {
          item.children.forEach((item2) => {
            if (this.$route.path.indexOf(item.link) != -1) item.isCurr = true;
          });
        }
      });
    },
    hideTel(phone) {
      let tel = JSON.stringify(JSON.parse(phone));
      tel = "" + tel;
      let arr = tel.split("");
      arr.splice(3, 4, "****");
      return arr.join("");
    },
    toLogin() {
      // this.$refs.login.loginDialogVisible = true
      this.$store.state.loginMode = 1;
      this.$store.commit("setLoginVisible", true);
    },
    toRegist() {
      this.$store.commit("setLoginVisible", false);
      setTimeout(() => {
        this.$store.commit("setRegVisible", true);
      }, 300);
    },
    toReg() {
      //this.$refs.reg.regDialogVisible = true
      this.$store.commit("setLoginVisible", true);
    },
    toChangePwd() {
      // this.$refs.changeReg.changeRegDialogVisible = true
      this.$store.commit("setForgetVisible", true);
    },
    //监听滚动事件
    handleScroll(e) {
      this.fixedDiv = window.pageYOffset >= 686 ? true : false;
    },
    toIllegalWord() {},
    //通过店长授权获取用户信息/api/Member/Member/GetKuaiOMemberInfo
    getKuaiOMemberInfo(token) {
      let ajaxData = {
        shopToolToken: token,
      };
      return new Promise((resolve, reject) => {
        this.$ajax.post("/kuaio/api/Member/Member/GetKuaiOMemberInfo", ajaxData).then((res) => {
          if (res.code == 200) {
            let { result } = res;
            resolve(result);
          }
          if (res.code != 200) {
            //this.$message.error(res.msg);
            resolve(false);
          }
        });
      });
    },
    //退出账号
    loginOut() {
      Cookies.remove("authorization");
      let userInfo = localStorage.getItem("userInfo");
      userInfo = userInfo ? JSON.parse(userInfo) : "";
      let opt = {
        userId: userInfo.kuaiOId ? userInfo.kuaiOId : "", //快哦id
        account: userInfo.userPhone ? userInfo.userPhone : "", //手机号
        functionTypeName: "快哦退出账号",
        projectName: "快哦",
        callback: (res) => {
          localStorage.removeItem("userInfo");
          window.location.reload();
        },
      };
      if (userInfo && userInfo.kuaiOId && userInfo.userPhone) this.$utils.buryingpoint(opt);
    },
    //刷新页面
    reload() {
      this.getAliPackageCount();
      this.$emit("reload");
    },
    //获取条数()
    getAliPackageCount() {
      if (!this.$checkLogin(true)) return;
      this.$store.dispatch("GetFwPackageQuantity");
    },
    async buyBtn(fwCheckType, fwPackageTimeType) {
      if (!this.$checkLogin()) return;
      /* this.$refs.chooseCombo.showOrder()
      return */
      this.$refs.chooseCombo.show(fwCheckType, fwPackageTimeType);
    },
    //1688 带token 直接绑定登录
    bindRegLogin(ajaxData) {
      this.$ajax.post("/kuaio/api/Member/Member/Register", ajaxData).then((res) => {
        if (res.code == 200) {
          this.$message.success({
            message: res.msg,
            duration: 1200,
          });
          let userInfo = {
            mobilePhone: Number(this.phone),
            password: this.password,
          };
          let pointData = {
            functionTypeName: "快哦注册",
            userId: res.result,
            account: Number(this.phone),
            callback: (resp) => {},
          };
          this.$utils.buryingpoint(pointData);
          this.toLogin(userInfo);
        }
        if (res.code != 200) this.$message.error(res.msg);
      });
    },
    showUserPack() {
      this.$refs.userPact.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.fixedDiv {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
}
.absoluteDiv {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
}
.navChildrenItem {
  padding: 5px 10px;
}
.navChildrenItem a:hover {
  color: #2268f4;
}
.notLogin .curp:hover {
  color: #fff;
}
.loginedView {
  .userInfoIcon {
    background: #f7f8fa;
    border-radius: 50%;
    padding: 10px 12px;
    cursor: pointer;
  }
}
.navBarView {
  width: 100%;
  .navBar {
    width: 1360px;
    height: 60px;
    margin: 0 auto;

    .logoText {
      color: rgba(255, 255, 255, 0.7);
    }
    .center {
      a {
        padding: 0 22px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
      }
      a:hover {
        color: #fff;
      }
      .curr {
        color: #fff;
      }
    }
    .right {
      color: rgba(255, 255, 255, 0.7);
    }
  }
}
.whiteNav {
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 2px #e1e1e1;
  .navBar {
    background: #fff;
    width: 1360px;
    height: 60px;
    margin: 0 auto;

    .logoText {
      color: #4e4e4e;
    }
    .center {
      a {
        padding: 0 22px;
        color: #222;
        cursor: pointer;
      }
      a:hover {
        color: #2268f4;
      }
      .curr {
        color: #2268f4;
      }
    }
    .right {
      color: #222;
    }
  }
  .notLogin .curp:hover {
    color: #2268f4;
  }
}
.iconClass {
  position: absolute;
  top: -17px;
  display: inline-block;
  right: -16px;
  color: #fff;
  padding: 3px 5px;
  line-height: 1;
  font-size: 12px;
  border-radius: 20px 20px 20px 0px;
}
.bg-red {
  background: red;
}
.bg-blue {
  background: rgb(11, 52, 236);
}
a {
  color: #333;
}
</style>
<style lang="scss">
.logined {
  padding: 0 !important;
  .userInfo {
    height: 220px;
    .account {
      height: 72px;
      background: #e8efff;
      padding: 0 20px;
    }
    .useStatus {
      height: 66px;
      padding: 15px 20px;
      border-bottom: 1px solid #eee;
      .buy {
        color: #1c64f4;
      }
    }
    .option {
      height: 82px;
      padding: 0 20px;
    }
  }
}
</style>
